import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CookiesHandlerService {
    constructor(private cookies: CookieService) {}

    clearCookiesOnLogout() {
        this.cookies.delete('token', '/');
        this.cookies.delete('userId', '/');
        this.cookies.delete('email', '/');
        this.cookies.delete('JSESSIONID', '/');
        this.cookies.delete('isSuperAdmin', '/');
        this.cookies.delete('userRole', '/');
        this.cookies.delete('VIEW_AS', '/');
        this.cookies.deleteAll('/tuwaiq');
        this.cookies.deleteAll('/', environment.domainWildCard);
    }
}
